import {FifthStep, MyButton} from "../../../../components";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {createSearchParams, generatePath, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {selectStore} from "../../../../store/selector";
import {Alert, Button, Col, Image, Row} from "antd";
import {
  StyledContent,
  StyledStepsButtons
} from "../../../../components/pages/Entrant/EntrantApplication/index.styles";
import {ROUTE_PATH} from "../../../../constants";
import iconDownload from "../../../../assets/icons/page/entrant/admission/icon_download.svg";
import {fetchGetInfoAction} from "../../../../store/pages/admission/actions";
import {decodeBase64} from "../../../../utils/decodeBase64";

export const UserApplicationsCurrent = () => {
  const navigate = useNavigate()
  const {t} = useTranslation(["admissionView", 'executorAdmissionSteps']);
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParams = searchParams.get('tab')

  const dispatch = useDispatch();
  const {id} = useParams();

  const decodedId = decodeBase64(id)

  const {admission: {getInfo}} = useSelector(selectStore)

  useEffect(() => {
    // user_id
    // @ts-ignore
    dispatch(fetchGetInfoAction({education_order_id: decodedId}))
  }, [])

  const handleClick = () => {
    let path = {
      pathname: generatePath(ROUTE_PATH.ENTRANT_USER_APPLICATIONS),
      // @ts-ignore
      search: createSearchParams({
        tab: tabParams ? tabParams : 1
      }).toString(),
    }

    navigate(path)
  }

  const takePdfReceiptHandler = () => {
    window.open(`${process.env.REACT_APP_URL_OLD_REST}${getInfo.data && getInfo.data.educationOrder.receipt_pdf_url}`, "_blank")
  }

  const renderExtraContent = () => {
    if (getInfo?.data?.educationOrder?.decline_reason) {
      return(
        <Row style={{padding: "24px 40px 0 40px"}}>
          <Alert style={{width: "100%"}} message={getInfo?.data?.educationOrder?.decline_reason} type="info" showIcon/>
        </Row>
      )
    } else {
      return null
    }
  }

  return (
    <Row justify='center' align='middle'>
      <Col span={20}>
        <Row>
          <Col span={24}>
            <div style={{backgroundColor: '#fff', marginTop: 32}}>
              <StyledContent>

                {getInfo?.data && getInfo?.data?.educationOrder?.receipt_pdf_url ? (
                  <Button
                    className="admission__button col-blue br-blue"
                    style={{position: "absolute", right: 20, top: 54}}
                    onClick={() => takePdfReceiptHandler()}
                  >
                    {t('admissionView:stepsButton.downloadRaspiska')}
                    <Image
                      src={iconDownload}
                      preview={false}
                      style={{paddingLeft: 12, position: "relative", bottom: 2}}
                    />
                  </Button>
                ) : null}
                <FifthStep educationOrder={getInfo.data} title={`Заявление №${decodedId}`} extraContent={renderExtraContent()}/>

                <Row justify='center'>
                  <Col>
                    <MyButton style={{marginBottom: 24}} onClick={handleClick}>
                      {t('admissionView:stepsButton.backToList')}
                    </MyButton>
                  </Col>
                </Row>
              </StyledContent>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}